import React from 'react';
import { technicalSkills } from '../data/mock';
import { Code } from 'lucide-react';
import '../styles/TechnicalSkills.css';

const TechnicalSkills = () => {
  return (
    <section className="technical-skills-section" id="skills">
      <div className="skills-container">
        <h2 className="section-title">Technical Skills</h2>
        
        <div className="skills-grid">
          {Object.entries(technicalSkills).map(([category, skills]) => (
            <div key={category} className="skill-category">
              <div className="category-header">
                <Code size={20} />
                <h3 className="category-title">{category}</h3>
              </div>
              <div className="skills-list">
                {skills.map((skill, idx) => (
                  <span key={idx} className="skill-item">{skill}</span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TechnicalSkills;
